import React from 'react';

const HoverButton = ({ children, className = '' }) => {
  return (
    <span className={`relative inline-flex overflow-hidden duration-300 group ${className}`}>
      {/* Default visible state */}
      <span className="translate-y-0 transition group-hover:-translate-y-[150%]">
        {children}
      </span>
      {/* Hover state (slides up from below) */}
      <span className="absolute translate-y-[150%] transition group-hover:translate-y-0" aria-hidden="true">
        {children}
      </span>
    </span>
  );
};

export default HoverButton;